import Suggestions from './suggestions';
export { default as SuggestionButton } from './suggestion-button';
export { default as SuggestionBox } from './suggestion-box';
export default Suggestions;
